import { requestGet, requestPost } from '@/utils/request';

const api = {
    LIST: '/op/moderate_list',
    PASSED: '/op/moderate_passed',
    REFUSE: '/op/moderate_refuse',
}

export async function moderateList(queryParams) {
    return requestGet(api.LIST, queryParams);
}

export async function moderatePassed(ids) {
    let params = {ids: ids};
    return requestPost(api.PASSED, params);
}

export async function moderateRefuse(formData) {
    return requestPost(api.REFUSE, formData);
}